import Widget from '@/utils/widgets/Widget'
import Geolocation from '@/utils/types/Geolocation.js'
import WidgetValidator from '@/utils/widgets/WidgetValidator.js'
export class TextWidget extends Widget {
  data = {
    hidden: false,
    text: ''
  }

  requiredFields = ['text']

  constructor (title) {
    super(title, 'TextWidget')
  }
}

export class HeadingWidget extends Widget {
  data = {
    hidden: false,
    title: '',
    subTitle: '',
    buttonTitle: '',
    buttonLink: ''
  }

  requiredFields = ['title']

  constructor (title) {
    super(title, 'HeadingWidget')
  }
}

export class SpacerWidget extends Widget {
  data = {
    hidden: false,
    size: 'S'
  }

  constructor (title) {
    super(title, 'SpacerWidget')
  }
}

export class NavPillsWidgetItem extends Widget {
  data = {
    title: '',
    iconCode: '',
    link: ''
  }

  requiredFields = ['title', 'link']

  constructor (title) {
    super(title, 'NavPillsWidgetItem')
  }
}

export class NavPillsWidget extends Widget {
  data = {
    hidden: false,
    pills: []
  }

  requiredFields = ['pills']
  requiredMsg = 'Хотя бы один элемент обязателен'

  _item = 'NavPillsWidgetItem'

  constructor (title) {
    super(title, 'NavPillsWidget')
  }
}

export class NavPillsLargeWidgetItem extends Widget {
  data = {
    title: '',
    subTitle: '',
    iconCode: '',
    link: ''
  }

  requiredFields = ['title', 'link']

  constructor (title) {
    super(title, 'NavPillsLargeWidgetItem')
  }
}

export class NavPillsLargeWidget extends Widget {
  data = {
    hidden: false,
    pills: []
  }

  requiredFields = ['pills']
  requiredMsg = 'Хотя бы один элемент обязателен'

  _item = 'NavPillsLargeWidgetItem'

  constructor (title) {
    super(title, 'NavPillsLargeWidget')
  }
}

export class ImageWidget extends Widget {
  data = {
    hidden: false,
    image: null,
    altText: '',
    caption: '',
    fit: '',
    width: '100%',
    height: '400px'
  }

  requiredFields = ['image']
  validators = {
    width: [new WidgetValidator('unitsValidator', 'Разрешены только единицы измерения')],
    height: [new WidgetValidator('unitsValidator', 'Разрешены только единицы измерения')]
  }

  constructor (title) {
    super(title, 'ImageWidget')
  }
}

export class VideoWidget extends Widget {
  data = {
    hidden: false,
    url: '',
    poster: '',
    caption: ''
  }

  requiredFields = ['url']
  validators = {
    url: [
      new WidgetValidator('url', 'Только url'),
      new WidgetValidator('youtubeVimeoVkRutube', 'Только youtube, vimeo, vk или rutube')
    ]
  }

  constructor (title) {
    super(title, 'VideoWidget')
  }
}

export class TextAndImageWidget extends Widget {
  data = {
    hidden: false,
    text: '',
    image: null,
    altText: '',
    fit: '',
    caption: '',
    width: '100%',
    height: '400px',
    horizontalFlip: false
  }

  requiredFields = ['text', 'image']
  validators = {
    width: [new WidgetValidator('unitsValidator', 'Разрешены только единицы измерения')],
    height: [new WidgetValidator('unitsValidator', 'Разрешены только единицы измерения')]
  }

  constructor (title) {
    super(title, 'TextAndImageWidget')
  }
}

export class CTABlockWidget extends Widget {
  data = {
    hidden: false,
    title: '',
    description: '',
    descriptionForMobile: '',
    buttonTitle: '',
    buttonLink: '',
    image: null,
    caption: ''
  }

  requiredFields = ['title']

  constructor (title) {
    super(title, 'CTABlockWidget')
  }
}

export class AdvertisingWidget extends Widget {
  data = {
    hidden: false,
    format: '',
    id: ''
  }

  requiredFields = ['id']

  constructor (title) {
    super(title, 'AdvertisingWidget')
  }
}

export class GalleryWidgetSlide extends Widget {
  data = {
    image: null,
    altText: '',
    fit: '',
    title: '',
    description: '',
    descriptionForMobile: '',
    buttonTitle: '',
    buttonLink: '',
    caption: ''
  }

  requiredFields = ['image']

  constructor (title) {
    super(title, 'GalleryWidgetSlide')
  }
}

export class GalleryWidget extends Widget {
  data = {
    hidden: false,
    height: '400px',
    width: '100%',
    slides: []
  }

  requiredFields = ['slides']
  requiredMsg = 'Хотя бы один элемент обязателен'
  validators = {
    width: [new WidgetValidator('unitsValidator', 'Разрешены только единицы измерения')],
    height: [new WidgetValidator('unitsValidator', 'Разрешены только единицы измерения')]
  }

  _item = 'GalleryWidgetSlide'

  constructor (title) {
    super(title, 'GalleryWidget')
  }
}

export class CardSetWidget extends Widget {
  data = {
    image: null,
    description: '',
    descriptionForMobile: '',
    link: '',
    title: '',
    caption: ''
  }

  requiredFields = ['image', 'link']

  constructor (title) {
    super(title, 'CardSetWidget')
  }
}

export class CardsSetWidget extends Widget {
  data = {
    layout: '',
    hidden: false,
    images: []
  }

  requiredFields = ['images']
  requiredMsg = 'Хотя бы один элемент обязателен'

  _item = 'CardSetWidget'

  constructor (title) {
    super(title, 'CardsSetWidget')
  }
}

export class MapWidget extends Widget {
  data = {
    hidden: false,
    address: new Geolocation(),
    zoom: 15
  }

  requiredFields = ['address.address']

  constructor (title) {
    super(title, 'MapWidget')
  }
}

export class RoutePoint extends Widget {
  data = {
    id: null,
    title: '',
    description: '',
    descriptionForMobile: '',
    sortOrder: 0,
    images: [],
    location: new Geolocation(),
    routeId: null,
    placeId: null
  }

  requiredFields = ['title', 'location.address']

  constructor (title) {
    super(title, 'RoutePoint')
  }
}

export class AudioguidePoint extends Widget {
  data = {
    id: null,
    title: '',
    description: '',
    descriptionForMobile: '',
    sortOrder: 0,
    images: [],
    location: new Geolocation(),
    audioId: null,
    audioguideId: null,
    placeId: null,
    translations: { ru: { isEnabled: true } }
  }

  requiredFields = ['title', 'audioId', 'location.address']

  constructor (title) {
    super(title, 'AudioguidePoint')
  }
}

export class DictionaryOption extends Widget {
  data = {
    id: null,
    value: '',
    label: ''
    // options: []
  }

  constructor (title) {
    super(title, 'DictionaryOption')
  }
}

export class HistoryFiguresWidget extends Widget {
  data = {
    id: null
  }

  constructor (title) {
    super(title, 'HistoryFiguresWidget')
  }
}

export class AdPlacementWidget extends Widget {
  data = {
    adPlacement: null
  }

  validators = {
    width: [new WidgetValidator('unitsValidator', 'Разрешены только единицы измерения')],
    height: [new WidgetValidator('unitsValidator', 'Разрешены только единицы измерения')]
  }

  constructor (title) {
    super(title, 'AdPlacementWidget')
  }
}

// FEEDS WIDGETS

// FEED
export class FilterFeedWidgetItem extends Widget {
  data = {
    field: null,
    condition: null,
    value: null
  }

  _item = 'FilterFeedWidgetItem'

  constructor (title) {
    super(title, 'FilterFeedWidgetItem')
  }
}
export class FeedWidget extends Widget {
  data = {
    hidden: false,
    where: [],
    orderBy: {
      title: '',
      value: ''
    },
    limit: 4
  }

  _item = 'FilterFeedWidgetItem'
}
export class StandardEventsFeedWidget extends FeedWidget {
  constructor (title) {
    super(title, 'StandardEventsFeedWidget')
  }
}
export class IntroEventsFeedWidget extends FeedWidget {
  constructor (title) {
    super(title, 'IntroEventsFeedWidget')
  }
}
export class SliderEventsFeedWidget extends FeedWidget {
  constructor (title) {
    super(title, 'SliderEventsFeedWidget')
  }
}
export class PagesFeedWidget extends FeedWidget {
  constructor (title) {
    super(title, 'PagesFeedWidget')
    this.data.layout = ''
  }
}
export class BlogFeedWidget extends FeedWidget {
  constructor (title) {
    super(title, 'BlogFeedWidget')
  }
}
export class PlacesFeedWidget extends FeedWidget {
  constructor (title) {
    super(title, 'PlacesFeedWidget')
    this.data.layout = ''
  }
}
export class CitiesFeedWidget extends FeedWidget {
  constructor (title) {
    super(title, 'CitiesFeedWidget')
    this.data.layout = ''
  }
}
export class RoutesFeedWidget extends FeedWidget {
  constructor (title) {
    super(title, 'RoutesFeedWidget')
    this.data.layout = ''
  }
}
export class AudioGuidesFeedWidget extends FeedWidget {
  constructor (title) {
    super(title, 'AudioGuidesFeedWidget')
    this.data.layout = ''
  }
}
export class HotelsFeedWidget extends FeedWidget {
  constructor (title) {
    super(title, 'HotelsFeedWidget')
    this.data.layout = ''
  }
}
// CHOSEN
export class ChosenWidget extends Widget {
  data = {
    hidden: false,
    where: {
      id: []
    },
    orderBy: {
      title: '',
      value: ''
    },
    limit: null
  }
}
export class EventsPlacesRelationChosenWidgetInput extends ChosenWidget {
  constructor (title) {
    super(title, 'EventsPlacesRelationChosenWidgetInput')
  }
}

/**
 * Used for Widget child creation
 * example:
 * const itemName = this.widget._item
 * const WidgetItem = widgetItems[itemName]
 * const newWidgetItem = new WidgetItem()
 */
export const widgetItems = {
  NavPillsWidgetItem,
  NavPillsLargeWidgetItem,
  GalleryWidgetSlide,
  FilterFeedWidgetItem,
  CardSetWidget
}

export const widgetsTypes = {
  TextWidget,
  HeadingWidget,
  SpacerWidget,
  NavPillsWidgetItem,
  NavPillsWidget,
  NavPillsLargeWidgetItem,
  NavPillsLargeWidget,
  ImageWidget,
  VideoWidget,
  TextAndImageWidget,
  CTABlockWidget,
  GalleryWidgetSlide,
  GalleryWidget,
  MapWidget,
  FilterFeedWidgetItem,
  FeedWidget,
  StandardEventsFeedWidget,
  IntroEventsFeedWidget,
  SliderEventsFeedWidget,
  PagesFeedWidget,
  BlogFeedWidget,
  PlacesFeedWidget,
  EventsPlacesRelationChosenWidgetInput,
  CitiesFeedWidget,
  RoutesFeedWidget,
  AudioGuidesFeedWidget,
  RoutePoint,
  AudioguidePoint,
  DictionaryOption,
  AdPlacementWidget,
  HotelsFeedWidget,
  CardsSetWidget,
  CardSetWidget,
  HistoryFiguresWidget
}
